define(['jquery','Magento_Customer/js/customer-data'],
    ($,customerData) => {
    class Criteo {
        defaultConfig = {};

        constructor({ config }) {
            this.config = {...this.defaultConfig, ...config};
            const customer = customerData.get('customer');
            const email =  customer().email ? customer().email.toLowerCase().trim() : '';
            const pageType = this.config.pageType;

            this.hashEmail(email).then((digestHex) =>
            {
                if (pageType === "home")
                {
                    dataLayer.push({
                        "HashedEmail": digestHex,
                        "PageType": "Homepage"
                    })
                }
                else if (pageType === "plp")
                {
                    dataLayer.push({
                        "HashedEmail": digestHex,
                        "PageType": "Listingpage",
                        "ProductIDList":  this.config.ProductIDList
                    });
                }
                else if (pageType === "pdp")
                {
                    var productData = this.config.Product;
                    productData['HashedEmail'] = digestHex;
                    productData['PageType'] = "Productpage";
                    dataLayer.push(productData);
                }
            });
        };

        async hashEmail(email, algorithm = 'SHA-256') {
            if(email !== '') {
                // Encode the email string into a Uint8Array
                const encoder = new TextEncoder();
                const data = encoder.encode(email);

                // Hash the data with SHA-256
                const hashBuffer = await crypto.subtle.digest(algorithm, data);

                // Convert the buffer to a hexadecimal string
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

                return hashHex;
            }
            return '';
        }

    }

    return ({ config }) => {
         return new Criteo({ config });
    };
});



